/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var Banners = {
    helper: {
      getUrlAnchor: function() {
        var url = document.location.toString();
        var urlAnchor = '';
        if (url.match('#')) {
          urlAnchor = url.split('#')[1];
        }
        return urlAnchor;
      },
      getParameterByName: function(name) {
        name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
        var regexS = '[\\?&]' + name + '=([^&#]*)';
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if(results == null) {
          return '';
        } else {
          return decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
      },
      reachGoal: function(goal_name, params) {
        params = params || {};
        var ym_counter_id = window.global_settings.ym_counter_id;
        if (!ym_counter_id) {
          return false;
        }
        window.ym(ym_counter_id, 'reachGoal', goal_name, params);
      },
      isVisible: function(jqueryEl) {
        var result = true;
        if ('hidden' === jqueryEl.css('visibility')) {
          result = false;
        }
        if ('none' === jqueryEl.css('display')) {
          result = false;
        }
        return result;
      },
    },
    functions: {
      onShowBanner: function(banner) {
        banner.shown_this_time = true;
        if (!banner.shown) {
          Utils.setCookie(Banners.functions.getShownCookieName(banner), '1', banner.shown_cookie_expiration);
          banner.shown = true;
        }
        if (!banner.show_goal_sent) {
          Banners.functions.reachGoal(banner, 'show');
          banner.show_goal_sent = true;
        }
      },
      reachGoal: function(banner, action_type) {
        if (!Utils.canSendGoals()) {
          return false;
        }

        var banner_ym_name = banner.ym_type+'_'+banner.ID+'_'+banner.title;
        var params = {
          ads_type: {},
        };
        params.ads_type[banner.ym_type] = {};
        params.ads_type[banner.ym_type][banner_ym_name] = {};
        params.ads_type[banner.ym_type][banner_ym_name][action_type] = 1;

        Banners.helper.reachGoal('ads_interaction', params);

        if (banner.ab_test) {
          var ab_params = {
            ab_tests: {},
          };
          var ab_test_ym_name = 'AB_'+banner.ab_test_id+'_'+banner.ab_test_title;
          var ab_step_ym_name = 'Этап_'+banner.ab_step;
          ab_params.ab_tests[ab_test_ym_name] = {};
          ab_params.ab_tests[ab_test_ym_name][ab_step_ym_name] = {};
          ab_params.ab_tests[ab_test_ym_name][ab_step_ym_name][banner_ym_name] = {};
          ab_params.ab_tests[ab_test_ym_name][ab_step_ym_name][banner_ym_name][action_type] = 1;

          Banners.helper.reachGoal('ab_tests', ab_params);

        }
      },
      insertIntoArticle: function(html, banner, areaWrapper) {
        if (typeof banner.position !== 'undefined') {
          var elemToInsertBanner;
          var content = areaWrapper.find('.entry-content');
          switch (banner.position.type) {
            case 'after-h1':
              elemToInsertBanner = content;
              elemToInsertBanner.prepend(html);
              break;
            case 'before-after-selector':
              elemToInsertBanner = content.children(banner.position.ba_selector).eq(banner.position.position_param);
              if (elemToInsertBanner && elemToInsertBanner.length) {
                if (banner.position.ba_before_after === 'before') {
                  elemToInsertBanner.before(html);
                } else {
                  elemToInsertBanner.after(html);
                }
              }
              break;
            case 'after-paragraph':
              elemToInsertBanner = content.children('p').eq(banner.position.position_param);
              if (elemToInsertBanner && elemToInsertBanner.length) {
                elemToInsertBanner.after(html);
              }
              break;
            case 'after-n-characters':
              var sumTextLength = 0;
              content.children('p').each(function(i,elem) {
                var self = $(elem);
                sumTextLength += self.text().length;
                if (sumTextLength >= banner.position.position_param) {
                  elemToInsertBanner = self;
                  return false;
                }
              });
              if (elemToInsertBanner && elemToInsertBanner.length) {
                elemToInsertBanner.after(html);
              }
              break;
            default:
          }
          if (!(elemToInsertBanner && elemToInsertBanner.length)) {
            content.append(html);
          }
        }
      },
      getJqueryElement: function(banner) {
        return $('[data-b-id="'+banner.ID+'"]');
      },
      getShownCookieName: function(item) {
        if (item.ab_test_id) {
          return 'bp_'+item.ab_test_id+'_shown';
        } else {
          return 'bp_'+item.ID+'_shown';
        }
      },
      getClickedCookieName: function(item_id) {
        return 'bp_'+item_id+'_clicked';
      },
      getClosedCookieName: function(item_id) {
        return 'bp_'+item_id+'_closed';
      },
      getShowCookieName: function(item_id) {
        return 'bp_'+item_id+'_show';
      },
      getHideCookieName: function(item_id) {
        return 'bp_'+item_id+'_hide';
      },
      getCookieNameByType: function(item_id, type) {
        return 'bp_'+item_id+'_'+type;
      },
      getABChosenCookieName: function(test_id, step) {
        return 'bp_ab_' + test_id + '_' + step + '_chosen';
      },
    },
    timers: {
      already_init: false,
      init: function() {
        if (!Banners.timers.already_init) {
          Banners.timers.siteTimer = new this.Timer(0);
          Banners.timers.pageTimer = new this.Timer(0);
          Banners.timers.startTimers();
          window.addEventListener('focus', Banners.timers.startTimers);
          window.addEventListener('pagehide', Banners.timers.stopTimers);
          window.addEventListener('beforeunload', Banners.timers.stopTimers);
          window.addEventListener('blur', Banners.timers.stopTimers);
          Banners.timers.already_init = true;
        }
      },
      Timer: function(start) {
        this.time = start;
        this.interval = 0;
        this.tick = function() {
          this.time++;
        };
        this.start = function() {
          if (!this.interval) {
            this.interval = setInterval(this.tick.bind(this), 1000);
          }
        };
        this.stop = function() {
          if (this.interval) {
            clearInterval(this.interval);
            this.interval = 0;
          }
        };
      },
      getTimeOnSite: function() {
        return +Banners.timers.siteTimer.time;
      },
      getTimeOnPage: function() {
        return +Banners.timers.pageTimer.time;
      },
      startTimers: function() {
        try {
          var sessionTime = sessionStorage.getItem('site_timer');
          if (sessionTime) {
            Banners.timers.siteTimer.time = sessionTime;
          }
        } catch (e) {}
        Banners.timers.siteTimer.start();
        Banners.timers.pageTimer.start();
      },
      stopTimers: function() {
        sessionStorage.setItem('site_timer', Banners.timers.siteTimer.time);
        Banners.timers.siteTimer.stop();
        Banners.timers.pageTimer.stop();
      },
    },
    exitIntent: {
      init: function() {
        var timeout = null;
        var touchStart = {};

        function triggerCallback() {
          document.documentElement.removeEventListener('mouseleave', onMouseLeave);
          document.documentElement.removeEventListener('mouseenter', onMouseEnter);
          document.documentElement.removeEventListener('click', clearTimeout);
          window.removeEventListener('touchstart', onTouchStart);
          window.removeEventListener('touchend', onTouchEnd);
          $(document).trigger('exitintent');
        }

        function clearTimeout() {
          if (timeout === null) {
            return;
          }

          window.clearTimeout(timeout);
          timeout = null;
        }

        function onMouseEnter() {
          clearTimeout();
        }

        function getAddressBarY() {
          if (document.documentMode || /Edge\//.test(navigator.userAgent)) {
            return 5;
          }

          return 0;
        }

        function onMouseLeave(evt) {
          clearTimeout(); // did mouse leave at top of window?
          // add small exception space in the top-right corner

          if (evt.clientY <= getAddressBarY() && evt.clientX < 0.80 * window.innerWidth) {
            timeout = window.setTimeout(triggerCallback, 400);
          }
        }

        function onTouchStart() {
          clearTimeout();
          touchStart = {
            timestamp: performance.now(),
            scrollY: window.scrollY,
            windowHeight: window.innerHeight,
          };
        }

        function onTouchEnd(evt) {
          clearTimeout(); // did address bar appear?

          if (window.innerHeight > touchStart.windowHeight) {
            return;
          } // allow a tiny tiny margin for error, to not fire on clicks


          if (window.scrollY + 20 >= touchStart.scrollY) {
            return;
          }

          if (performance.now() - touchStart.timestamp > 300) {
            return;
          }

          if (['A', 'INPUT', 'BUTTON'].indexOf(evt.target.tagName) > -1) {
            return;
          }

          timeout = window.setTimeout(triggerCallback, 800);
        }

        window.addEventListener('touchstart', onTouchStart);
        window.addEventListener('touchend', onTouchEnd);
        document.documentElement.addEventListener('mouseenter', onMouseEnter);
        document.documentElement.addEventListener('mouseleave', onMouseLeave);
        document.documentElement.addEventListener('click', clearTimeout);
      },
    },
    hellobar: {
      getHtml: function(banner) {
        var template;
        var mainText = '<span class="main-text-wrapper">' + banner.text22 + '</span>';
        var addText = '<span class="add-text-wrapper">' + banner.englex_html + '</span>';
        template = '<div class="hellobar-wrapper hellobar-wrapper-23 is-fixed ' + banner.classes22 + '" data-b-id="' + banner.ID + '" ><div class="position-relative">';
        template += banner.link_html22;
        template += '<div class="container"><div class="hellobar-inner">';
        template += '<button class="hellobar-close"><span class="close-icon"></span></button>';
        template += banner.img_html22;
        template += '<div class="text-wrapper">' + mainText + addText + '</div>';
        template += '<div class="btn-wrapper">' + banner.btn_html + '</div>';
        template += '</div></div></div></div>';

        return template;
      },
      render: function(banner) {
        var html = Banners.hellobar.getHtml(banner);
        $('body').prepend(html);
        $(window).trigger('resize');
        setTimeout(function() {
          $(document).trigger('hellobar.show');
        }, 500);
        banner.jqueryElement = Banners.functions.getJqueryElement(banner);
        banner.jqueryElementClicks = banner.jqueryElement.find('a');
        banner.jqueryElementClose = banner.jqueryElement.find('.hellobar-close');
      },
      checkScrollCriterias: function(scrollHeight, banner, scrollY) {
        if (banner.trigger === 'percentage') {
          banner.triggerHeight = banner.trigger_percentage / 100 * $(document).height();
          if (scrollHeight > banner.triggerHeight) {
            Banners.hellobar.showHellobar22(banner);
            banner.triggered = true;
            return true;
          }
        } else {
          var triggerPx = banner.trigger_pixels || 600;
          if (scrollY > triggerPx) {
            Banners.hellobar.showHellobar22(banner);
            return true;
          }
        }
      },
      showHellobar22: function(banner) {
        banner.jqueryElement.slideDown('slow');
        Banners.functions.onShowBanner(banner);
      },
    },
    incut: {
      getHtml: function(banner) {
        var template = '<a href="' + banner.link + '" title="' + banner.link_title + '" ' + banner.link_new_tab + ' ' + banner.reachgoal;
        template += ' class="link-unstyled b-incut englex-info-block bt_img3 '+banner.extra_class+'" data-b-id="' + banner.ID + '"><div>';
        template += '<img class="b-visible-1 img-fluid" ' + banner.image_small_src + ' ' + banner.image_small_srcset + '/>';
        template += '<img class="b-visible-2 img-fluid" ' + banner.image_medium_src + ' ' + banner.image_medium_srcset + '/>';
        template += '<img class="b-visible-3 img-fluid" ' + banner.image_large_src + ' ' + banner.image_large_srcset + '/>';
        template += '</div></a>';

        return template;
      },
      render: function(banner) {
        var html = Banners.incut.getHtml(banner);
        Banners.functions.insertIntoArticle(html, banner, banner.areaWrapper);
      },
    },
    stb: {
      init: function() {
        Banners.timers.init();
        Banners.exitIntent.init();
      },
      getHtml: function(banner) {
        var template = '<div class="stb-container stb-' + banner.position +'-container">';
        template += '<div id="stb-' + banner.ID +'" class="' + banner.classes + '" style="display: none;" data-b-id="' + banner.ID + '">';
        template += '<div class="stb-content">' + banner.html + '</div>';
        template += '<span class="stb-close">' + banner.close_icon + '</span>';
        template += '</div>';
        template += '</div>';
        return template;
      },
      render: function(banner) {
        var html = Banners.stb.getHtml(banner);

        var style='<style type="text/css">' + banner.css + '</style>';

        $('head').append(style);

        var body = $('body');
        body.append(html);
        if ($('.stb-overlay').length === 0) {
          body.append('<div class="stb-overlay" style="display: none"></div>');
        }

        banner.jqueryElement = Banners.functions.getJqueryElement(banner);
        banner.jqueryElementClicks = banner.jqueryElement.find('.stb-action-target');
        banner.jqueryElementClose = banner.jqueryElement.find('.stb-close');

        setTimeout(function() {
          Banners.stb.addStbStyles(banner);
          if (banner.trigger === 'percentage' && banner.trigger_percentage === '0') {
            Banners.stb.showStb(banner);
          } else {
            // auto-show the box if box is referenced from URL
            if (Banners.helper.getUrlAnchor() === 'stb-'+banner.ID) {
              Banners.stb.showStb(banner);
            }
          }
        }, 1000);

        if (banner.trigger === 'time_on_site' || banner.trigger === 'time_on_page') {
          setInterval(function() {
            if (banner.shown_this_time) {
              return false;
            }
            if (banner.trigger === 'time_on_site' && Banners.timers.getTimeOnSite() >= +banner.trigger_site_time) {
              Banners.stb.showStb(banner);
            }
            if (banner.trigger=== 'time_on_page' && Banners.timers.getTimeOnPage() >= +banner.trigger_page_time) {
              Banners.stb.showStb(banner);
            }
          }, 1000);
        }

        if (banner.trigger === 'exit_intent') {
          $(document).on('exitintent', function() {
            Banners.stb.showStb(banner);
          });
        }

      },
      checkScrollCriterias: function(scrollHeight, banner) {
        if (banner.trigger !== 'percentage') {
          return false;
        }
        if (banner.shown_this_time) {
          return false;
        }

        banner.triggerHeight = banner.trigger_percentage / 100 * $(document).height();

        if (scrollHeight > banner.triggerHeight) {
          if (!banner.visible) {
            Banners.stb.showStb(banner, true);
            banner.triggered = true;
            return true;
          }
        }
      },
      showStb: function(banner, onscroll) {
        if ($('body').hasClass('modal-open')) {
          return;
        }

        onscroll = onscroll || false;
        if (!onscroll) {
          Banners.functions.onShowBanner(banner);
        }
        if (banner.position === 'center') {
          $('.stb-overlay').fadeIn('slow');
        }
        if (banner.animation === 'slide') {
          banner.jqueryElement.slideDown('slow');
        } else {
          banner.jqueryElement.fadeIn('slow');
        }
        $(document).trigger('stb.show', banner);
      },
      closeStb: function(banner) {
        if (banner.position === 'center') {
          $('.stb-overlay').fadeOut('slow');
        }
        if (banner.animation === 'slide') {
          banner.jqueryElement.slideUp('slow');
        } else {
          banner.jqueryElement.fadeOut('slow');
        }
        $(document).trigger('stb.close', banner);

      },
      addStbStyles: function(banner) {
        addStyles(banner);
        $(window).on('resize', function() {
          addStyles(banner);
        });

        function addStyles(banner) {
          // reset element to its initial state
          banner.jqueryElement.css('maxHeight', 'none');
          banner.jqueryElement.css('overflowY', 'auto');

          // get new dimensions
          var windowHeight = $(window).height();
          var boxHeight = banner.jqueryElement.outerHeight();

          // does box + margin fit on screen?
          if (boxHeight > windowHeight) {
            // add scrollbar to box and limit height
            banner.jqueryElement.css('maxHeight', windowHeight + 'px');
            banner.jqueryElement.css('overflowY', 'scroll');
          }

          // set new top margin for boxes which are centered
          if (banner.position === 'center') {
            var newTopMargin = ((windowHeight - boxHeight) / 2);
            if (newTopMargin < 0) newTopMargin = 0;
            banner.jqueryElement.css('marginTop', newTopMargin + 'px');
          }
        }
      }
    },
    init: function() {
      if (typeof(window.banners_data) !== 'undefined') {
        var banners_data = window.banners_data;

        (function setCookiesFromGetParams() {
          for (var i = 0; i < banners_data.get_params.length; i++) {
            var get_param_data = banners_data.get_params[i];
            var get_param_value = Banners.helper.getParameterByName(get_param_data.name);
            if (get_param_value === get_param_data.value) {
              Utils.setCookie(Banners.functions.getCookieNameByType(get_param_data.banner_id, get_param_data.type), '1', get_param_data.days);
            }
          }
        })();

        Banners.stb.init();

        var banners = banners_data.banners;
        var area_options = banners_data.area_options;
        var ab_tests = banners_data.ab_tests;
        var types = banners_data.banners_types;
        var inserted_banners = [];
        for (var type in banners) {
          for (var area in banners[type]) {
            var areaWrapper = $('[data-b-type="'+type+'"][data-b-area="'+area+'"]');
            var bannersArray = Object.values(banners[type][area]);
            if (areaWrapper.length && bannersArray.length) {
              var filteredBanners = filterBanners(bannersArray, ab_tests, area_options[type][area], banners_data.global_options);
              for (var i = 0; i < filteredBanners.length; i++) {
                var banner = filteredBanners[i];

                banner.type = type;
                banner.areaWrapper = areaWrapper;
                renderBanner(banner);
                if (typeof(banner.jqueryElement) === 'undefined') {
                  banner.jqueryElement = Banners.functions.getJqueryElement(banner);
                }
                if (typeof(banner.jqueryElementClicks) === 'undefined') {
                  banner.jqueryElementClicks = banner.jqueryElement;
                }
                inserted_banners.push(banner);
              }
            }
          }
        }
        Banners.track(inserted_banners);
      }

      function filterBanners(list, ab_tests, options, global_options) {
        options = options || {};
        global_options = global_options || {};

        // first - check ab_tests
        var remove_ids = {};
        ab_tests.forEach(function(ab_test) {
          var test_members = ab_test.members;
          // check for 'chosen' cookie
          var cookie_name = Banners.functions.getABChosenCookieName(ab_test.test_id, ab_test.step);
          var chosen_member = +Utils.getCookie(cookie_name);
          // if cookie not exists - choose now
          if (!chosen_member) {
            var rand = Math.floor(Math.random() * test_members.length);
            Utils.setCookie(cookie_name, test_members[rand], 10*365);
            chosen_member = test_members[rand];
          }
          // remove all test members except chosen
          test_members.forEach(function(test_members_id) {
            if (test_members_id !== chosen_member) {
              remove_ids[test_members_id] = true;
            }
          });
        });
        list = list.filter(function(list_item) {
          if (typeof(remove_ids[list_item.ID]) !== 'undefined') {
            return false;
          }
          return true;
        });


        // filter by englexStudent
        list = list.filter(function(list_item) {
          if (list_item.not_for_existing_students) {
            if (Utils.getCookie('englexStudent') || Utils.getCookie('englexrequest')) {
              return false;
            }
          }
          return true;
        });


        // filter by GET params and other cookies
        list = list.filter(function(list_item) {
          if (list_item.getparams_show_only) {
            if (!Utils.getCookie(Banners.functions.getShowCookieName(list_item.ID))) {
              return false;
            }
          } else if (list_item.getparams_hide_only) {
            if (Utils.getCookie(Banners.functions.getHideCookieName(list_item.ID))) {
              return false;
            }
          }
          return true;
        });


        // split shown and not-shown banners
        var shown_banners_list = [];
        var not_shown_banners_list = [];
        list.forEach(function(list_item) {
          var filter_cookie_name;
          if (type === types.BANNERS_TYPE_HELLOBAR) {
            filter_cookie_name = Banners.functions.getClosedCookieName(list_item.ID);
          } else {
            filter_cookie_name = Banners.functions.getShownCookieName(list_item);
          }
          var filtered = Utils.getCookie(filter_cookie_name);
          if (filtered) {
            // banners from ab-tests show only once
            if (!list_item.ab_test) {
              list_item.shown = true;
              shown_banners_list.push(list_item);
            }
          } else {
            list_item.shown = false;
            not_shown_banners_list.push(list_item);
          }
        });
        list = not_shown_banners_list;


        // filter by priority
        list.sort(function(a, b) {
          var res;
          if (a.no_others && b.no_others) {
            res	= parseInt(a.display_priority) - parseInt(b.display_priority);
            // random order if equal priority
            if (res === 0) {
              res = 0.5 - Math.random();
            }
          } else if (!a.no_others && !b.no_others) {
            res = 0.5 - Math.random();
          } else {
            res = (b.no_others ? 1: 0) - (a.no_others ? 1 : 0);
          }
          return res;
        });
        if (list.length && list[0].no_others) {
          list = list.slice(0, 1);
        }


        if (global_options.show_random_shown) {
          // if list is empty - show random already shown banner again
          if (list.length === 0) {
            if (shown_banners_list.length !== 0) {
              var rand = Math.floor(Math.random() * shown_banners_list.length);
              list = [shown_banners_list[rand]];
            }
          }
        }


        // last - filter by count
        var max = options.max || 1;
        return list.slice(0, max);
      }

      function renderBanner(banner) {
        if (banner.type === types.BANNERS_TYPE_HELLOBAR) {
          Banners.hellobar.render(banner);
        } else if (banner.type === types.BANNERS_TYPE_INCUT) {
          Banners.incut.render(banner);
        } else if (banner.type === types.BANNERS_TYPE_STB) {
          Banners.stb.render(banner);
        }
      }
    },
    track: function(inserted_banners) {
      var types = banners_data.banners_types;

      (function trackScrolling() {
        var scrollTimer = 0;
        $(window).on('scroll', function() {
          if (scrollTimer) {
            clearTimeout(scrollTimer);
          }
          scrollTimer = setTimeout(function() {
            var scrollY = $(window).scrollTop();
            var scrollHeight = scrollY + window.innerHeight;
            inserted_banners.forEach(function(banner) {
              if (isShownOnScroll(scrollHeight, banner, scrollY)) {
                Banners.functions.onShowBanner(banner);
              }
            });
          }, 100);
        });
      })();

      (function trackClicks() {
        inserted_banners.forEach(function(banner) {
          banner.jqueryElementClicks.on('click', function() {
            Utils.setCookie(Banners.functions.getClickedCookieName(banner.ID), '1', 15);
            Banners.functions.reachGoal(banner, 'click');
            if (banner.type === types.BANNERS_TYPE_HELLOBAR) {
              // only hellobars close on click links inside
              Utils.setCookie(Banners.functions.getClosedCookieName(banner.ID), '1', banner.shown_cookie_expiration);
              banner.jqueryElement.remove();
            }
          });
          if (typeof(banner.jqueryElementClose) !== 'undefined') {
            banner.jqueryElementClose.on('click', function() {
              Utils.setCookie(Banners.functions.getClosedCookieName(banner.ID), '1', 15);
              Banners.functions.reachGoal(banner, 'close');
              if (banner.type === types.BANNERS_TYPE_STB) {
                Banners.stb.closeStb(banner);
              }
              if (banner.type === types.BANNERS_TYPE_HELLOBAR) {
                banner.jqueryElement.remove();
              }
            });
          }
          if (banner.type === types.BANNERS_TYPE_STB) {
            $('a[href="#stb-'+banner.ID+'"]').on('click', function() {
              stb.showStb(banner);
              return false;
            });
          }
        });
      })();

      function isShownOnScroll(scrollHeight, banner, scrollY) {
        var result = false;

        if (banner.type === types.BANNERS_TYPE_STB) {
          result = Banners.stb.checkScrollCriterias(scrollHeight, banner);
        }
        else if (banner.type === types.BANNERS_TYPE_HELLOBAR) {
          result = Banners.hellobar.checkScrollCriterias(scrollHeight, banner, scrollY);
        }
        else {
          banner.triggerHeight = banner.jqueryElement.offset().top + banner.jqueryElement.height();
          if (scrollHeight > banner.triggerHeight && Banners.helper.isVisible(banner.jqueryElement)) {
            result = true;
          }
        }
        return result;
      }
    },
    addIncutForSeoTest: function() {
      var inserted_banners = [];
      if ((typeof asti !== 'undefined')) {
        $('[data-asti-id]').each(function() {
          var target = $(this);
          var banner_id = target.attr('data-asti-id');
          var banner = asti[banner_id];

          if (!banner.not_for_existing_students || (!Utils.getCookie('englexStudent') && !Utils.getCookie('englexrequest'))) {
            var html = Banners.incut.getHtml(banner);
            target.html(html);
            $(document).on('click', '[data-asti-id="'+banner_id+'"] .b-incut', function() {
              Utils.reachGoal(target.attr('data-asti-goal'));
            });

            if (typeof(banner.jqueryElement) === 'undefined') {
              banner.jqueryElement = Banners.functions.getJqueryElement(banner);
            }
            if (typeof(banner.jqueryElementClicks) === 'undefined') {
              banner.jqueryElementClicks = banner.jqueryElement;
            }
            inserted_banners.push(banner);
          }
        });
        Banners.track(inserted_banners);
      }
    },
    customStb: function() {
      $(document).on('stb.show', function(e, stb) {
        var stbEl = $(stb.jqueryElement);
        var goalOnShowEl = stbEl.find('input[name="goalOnShow"]');
        if (goalOnShowEl && goalOnShowEl.val()) {
          Utils.reachGoal(goalOnShowEl.val());
        }
        var popoverToggle = stbEl.find('[data-toggle="popover"]');
        popoverToggle.each(function() {
          $(this).popover();
        });
        stbEl.find('.callback-number').each(function() {
          Forms.initPhoneInputs($(this).find('input').first());
        });
        if (stbEl.find('.signup-wrapper').length) {
          Forms.trackFill(stbEl);
          stbEl.find('form').on('inputFilled', function(e) {
            Utils.reachGoal('fillOneSignupFormStb_'+stb.ID);
          }).on('inputsFilled', function(e) {
            Utils.reachGoal('fillAllSignupFormStb_'+stb.ID);
          });
        }
      });

      $(document).on('stb.close', function(e, stb) {
        var stbEl = $(stb.jqueryElement);
        if (stbEl.find('.signup-wrapper').length) {
          Utils.reachGoal('closeSignupFormStb_'+stb.ID);
        }
      });
    },
  };

  var Forms = {
    initSubscribeForm: function() {
      var submitBtnSelector = '.subscribe-submit';
      var modalSelector = '.subscribe-modal, .on-page-form-container';
      var wrapperSuccessClass = 'success',
        titleSuccessClass = 'success-title',
        successTitle = 'Спасибо';
      var successCallback = function(submitButton, form, response) {
        var targetName = form.find('input[name="targetName"]').val();
        if (targetName) {
          Utils.reachGoal(targetName);
        }
        Utils.reachGoal('email_subscription');
        if (submitButton.hasClass('main-subscribe-form-submit')) {
          Utils.setCookie('sticky_subscribe_closed', 'true', 3650);
        }

        var mc4wpForm = submitButton.closest('.mc4wp-form');

        var behavior = form.find('input[name="behavior"]').val();
        if (behavior === 'toast') {
          if (form.attr('data-success-text')) {
            Notify._show('success', form.attr('data-success-text'));
            form[0].reset();
            form.find('.gfield_label').removeClass('active');
          }
        } else {
          form.hide();
          mc4wpForm.parent().append('<div class="mc4wp-response"><div class="mc4wp-alert mc4wp-success">'+form.attr('data-success-text')+'</div></div>');
        }

        var modal = submitButton.closest(modalSelector);
        if (behavior !== 'toast') {
          modal.addClass(wrapperSuccessClass)
            .find('.modal-title')
            .addClass(titleSuccessClass)
            .text(successTitle);
        }

        mc4wpForm.trigger("subscribe.success");

        var customRedirectUrl = form.find('input[name="redirectUrl"]').val();
        if (customRedirectUrl) {
          Utils.redirectOnSuccessfulSubscribe(customRedirectUrl);
        }
      };
      var errorCallback = function(form, response) {
        var behavior = form.find('input[name="behavior"]').val();
        if (behavior === 'toast') {
          if (form.attr('data-error-text')) {
            Notify._show('error', form.attr('data-error-text'));
          }
        } else {
          var errorContainer = form.find('.error-container');
          errorContainer.html('<div class="mc4wp-response"><div class="mc4wp-alert mc4wp-error">'+form.attr('data-error-text')+'</div></div>');
        }
      };
      Forms.initCustomForm(submitBtnSelector, successCallback, errorCallback);
      $(modalSelector).on('hidden.bs.modal', function(event) {
        // clear form
        var modal = $(event.currentTarget);
        var form = modal.find('form');
        // Remove possibly added classes
        modal.find('.gfield').removeClass('gfield_error');
        modal.find('.gfield_label').removeClass('active');
        // Hide possible errors from previous sign-up request
        modal.find('.validation_message').remove();
        modal.find('.error-container').empty();
        form.trigger('reset');
        form.show();
        modal.removeClass(wrapperSuccessClass)
          .find('.modal-title')
          .removeClass(titleSuccessClass)
          .html(modal.attr('data-subscribe-title'));
      });
    },
    initCustomSignupForm: function() {
      var successCallback = function(submitButton, form, response) {
        var signupBlock = form.closest('.signup-block');
        if (!signupBlock.length) {
          signupBlock = form.closest('.form-wrapper');
        }
        signupBlock.addClass('on-confirmation');
        form.hide();
        signupBlock.find('.gravity-form').append(response.confirmation);
        Forms.onSignupConfirmation(signupBlock.find('.gforms_confirmation_message'));
      };
      var errorCallback = function(form, response) {
        if (response && (response.result === 'captcha')) { // don't show error result
          if (form.find('.signup-captcha-wrapper').length === 0) { // load captcha if need
            $.ajax({
              type: 'POST',
              url: resources_ajax.ajax_url,
              dataType: 'html',
              data: 'action=lttrs_get_signup_captcha',
              success: function(html) {
                form.find('.gform_fields').append(html).addClass('has-captcha');
                $(document).on('signup_captcha_checked', function(e) {
                  var input = form.find('input[name="captchaToken"]');
                  input.val(e.detail.token);
                });
              },
            });
          }
        } else {
          form.closest('.signup-block').addClass('on-confirmation');
          form.closest('.gravity-form').html('Ошибка. Попробуйте позже или используйте другой email-адрес.');
        }
      };
      Forms.initCustomForm('.signup-submit', successCallback, errorCallback);
      $(document).on('hidden.bs.modal', '.signup-modal, .sign-up-modal, .englishchoice-signup-modal', function() {
        var modal = $(this);
        modal.find('.signup-block.on-confirmation').removeClass('on-confirmation');
        modal.find('.form-wrapper.on-confirmation').removeClass('on-confirmation');
        modal.find('.gfield').removeClass('gfield_error');
        modal.find('.gfield_label').removeClass('active');
        modal.find('.flag-container').removeClass('active');
        modal.find('.validation_message').remove();
        modal.find('form').trigger('reset').show();
        modal.find('.gforms_confirmation_message').remove();
        modal.find('.signup-captcha-wrapper').remove();
      });
      $(document).on('click', '.signup-block input[name="fname"]', function() {
        Utils.reachGoal('click-field-name');
      });
    },
    initContactOrRecallForm: function() {
      var successCallback = function(submitButton, form, response) {
        var currentModal = form.closest('.gform-modal');
        currentModal.addClass('on-confirmation');
        var successTitle = currentModal.attr('data-success-title');
        if (successTitle) {
          currentModal.find('.modal-title').addClass('success-title').html(successTitle);
        }
        form.hide();
        currentModal.find('.gravity-form').append(response.confirmation);
      };
      var errorCallback = function(form, response) {
        form.find('.gform_footer .validation_error').remove();
        form.find('.gform_footer').append('<div class="validation_error"><span class="validation-error-text">Ошибка. Попробуйте позже или используйте другой email-адрес.</span></div>');
      };
      Forms.initCustomForm('.contact-form-submit', successCallback, errorCallback);
      $(document).on('hidden.bs.modal', '.gform-modal', function() {
        var modal = $(this);
        modal.removeClass('on-confirmation');
        modal.find('.modal-title').removeClass('success-title').html(modal.attr('data-title'));
        modal.find('.gfield').removeClass('gfield_error');
        modal.find('.gfield_label').removeClass('active');
        modal.find('.flag-container').removeClass('active');
        modal.find('.validation_message').remove();
        modal.find('form').trigger('reset').show();
        modal.find('.gforms_confirmation_message').remove();
      });
    },
    initCustomForm: function(submitBtnSelector, successCallback, errorCallback) {
      $('body').on('click', submitBtnSelector, function(e) {
        var submitButton = $(this);
        var submitText = submitButton.text();
        var form = submitButton.closest('form');
        var recaptchaV3Input = form.find('input[name="g-recaptcha-response"][data-type="v3"]');
        if (recaptchaV3Input.length) {
          recaptchaV3Input.val($('#g-recaptcha-response').val());
        }
        var formInputs = form.find('input');
        var isFormValid = Forms.commonCustomFormValidation(form, '.gfield');
        var formData = form.serialize();
        formData += '&sourceUrl=' + document.location.href;
        if (isFormValid) {
          Forms.onFormValid(submitButton, form);
          form.addClass('loading');
          submitButton.prop('disabled', 'disabled').text('Отправляем...');
          $.ajax({
            'type': form.attr('method'),
            'url': resources_ajax.ajax_url,
            'data': formData,
            'cache': false,
            'timeout': 5000,
            'success': function(response) {
              response = JSON.parse(response);
              submitButton.prop('disabled', false).text(submitText);
              formInputs.prop('disabled', false);
              if (response && (response.result === 'success')) {
                successCallback(submitButton, form, response);
              } else {
                errorCallback(form, response);
              }
              if (recaptchaV3Input.length) {
                Forms.executeRecaptcha();
              }
            },
            'error': function(jqXHR, textStatus, errorThrown) {
              console.log(jqXHR);
              console.log(textStatus);
              console.log(errorThrown);
              errorCallback(form);
            }
          });
        }
        e.preventDefault();
      });
    },
    commonCustomFormValidation: function(form, inputWrapperSelector) {
      var formInputs = form.find('input'),
        error = {
          invalidName: false,
          invalidMail: false,
          invalidPhone: false,
        },
        errorPointNameText = 'invalidName',
        errorPointEmailText = 'invalidMail',
        errorPointPhoneText = 'invalidPhone',
        filterMail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var inputErrorBehaviour = function(target, errorPoint, errorText) {
        var parentInputWrapper = target.parents(inputWrapperSelector);
        parentInputWrapper.removeClass('not-empty').addClass('gfield_error');
        if (parentInputWrapper.children('.validation_message').length === 0) {
          target.parent().after('<div class="gfield_description validation_message"><span class="validation-message-text">' + errorText + '</span></div>');
        }
        switch (errorPoint) {
          case errorPointNameText:
            error.invalidName = true;
            break;
          case errorPointEmailText:
            error.invalidMail = true;
            break;
          case errorPointPhoneText:
            error.invalidPhone = true;
            break;
        }
      };
      var inputClearErrorBehaviour = function(target, errorPoint) {
        var parentInputWrapper = target.parents(inputWrapperSelector);
        parentInputWrapper.removeClass('gfield_error');
        parentInputWrapper.find('.validation_message').remove();
        switch (errorPoint) {
          case errorPointNameText:
            error.invalidName = false;
            break;
          case errorPointEmailText:
            error.invalidMail = false;
            break;
          case errorPointPhoneText:
            error.invalidPhone = false;
            break;
        }
      };
      formInputs.each(function() {
        var self = $(this),
          inputName = self.attr('name'),
          inputVal = self.val();
        if (inputName === 'fname') {
          if (!inputVal) {
            inputErrorBehaviour(self, errorPointNameText, 'Введите имя');
          } else {
            inputClearErrorBehaviour(self);
          }
        }
        if (inputName === 'email') {
          if (!inputVal || !filterMail.test(email = $.trim(inputVal))) {
            inputErrorBehaviour(self, errorPointEmailText, 'Введите правильный email');
          } else {
            inputClearErrorBehaviour(self);
          }
        }
        if (inputName === 'phone' && self.attr('required') === 'required') {
          if (!inputVal) {
            inputErrorBehaviour(self, errorPointPhoneText, 'Введите телефон');
          } else {
            inputClearErrorBehaviour(self);
          }
        }
      });
      if (!error.invalidName && !error.invalidMail && !error.invalidPhone) {
        return true;
      }
      else {
        return false;
      }
    },
    onFormValid: function(submitButton, form) {
      if (submitButton.hasClass('btn-submit-test-cg')) {
        Forms.sendTestCheckGoal(submitButton, form);
      }
    },

    onSignupConfirmation: function(signUpConfirmation) {
      if (Utils.canSendGoals()) {
        if (signUpConfirmation.closest('.stb-signup-container').length) {
          Utils.reachGoal('submitSignupFormStb_'+signUpConfirmation.closest('.stb-signup-container').attr('data-b-id'));
        }
        Utils.reachGoal('submit-sign-up-form', redirect_to_pc, redirect_to_pc);
      } else if ((typeof fpa_settings !== 'undefined') && (typeof window.ym !== 'undefined')) {
        window.ym(fpa_settings.custom_ym_counter_id, 'reachGoal', 'new_registration');
        redirect_to_pc();
      } else {
        redirect_to_pc();
      }
      function redirect_to_pc() {
        setTimeout(function() {
          var authUrl = signUpConfirmation.find('input[name="authUrl"]').val();
          if (authUrl) {
            document.location.href = authUrl;
          }
        }, 1000);
      }
    },


    /**
     * Material label position
     */
    gFormMaterialLabelUp: function() {
      //condition fixes scrollbar bug
      var self = $(this);
      if (self.prop('tagName') != 'DIV') {
        var value = self.val(),
          gfield = self.closest('.gfield'),
          placeholder = gfield.find('.gfield_label'),
          flag = gfield.find('.flag-container');
        if (placeholder.length) {
          placeholder.toggleClass('active', value.length > 0);
        }
        if (flag.length) {
          flag.toggleClass('active', value.length > 0);
        }
      }
    },
    gFormDelegateState: function(event) {
      var labelFocusClass = 'active-focus',
        wrapperFocusClass = 'focus-within',
        isFlagFocus = false;

      // Don't lose focus if clicked on intTelInput flag
      if ('focusout' == event.type) {
        if ($(event.relatedTarget).hasClass('selected-flag')) {
          isFlagFocus = true;
        }
      }
      if (!isFlagFocus) {
        $(this).parents('.gfield-material').find('.gfield_label' + ', .flag-container').toggleClass(labelFocusClass, 'focusin' == event.type);
      }

      $(this).parents('.gfield-material').find('.scroll-wrapper').toggleClass(wrapperFocusClass, 'focusin' == event.type);
    },

    /**
     * Trigger "inputFilled" event
     */
    offFillEvents: function() {
      $(document).on('inputFilled', function(e) {
        $(e.target).find('input').off('change.inputFilled');
      }).on('inputsFilled', function(e) {
        $(e.target).find('input').off('change.inputsFilled');
      });
    },
    trackFill: function(container) {
      container.find('form input').on('change.inputFilled', function() {
        var input = $(this);
        var form = input.closest('form');
        if (input.val()) {
          form.trigger('inputFilled');
        }
      }).on('change.inputsFilled', function() {
        var input = $(this);
        var form = input.closest('form');
        var inputs = form.find('input:visible');
        var filledInputs = inputs.filter(function() {
          return ('' !== this.value);
        });
        if (inputs.length === filledInputs.length) {
          form.trigger('inputsFilled');
        }
      });
    },

    filterInputCharactersInit: function(inputSelector, regExp) {
      $(inputSelector).on('focus keyup change', function(e) {
        var input = $(this),
          value = input.val(),
          newValue = value.replace(regExp, '');
        if (newValue !== value) {
          input.val(newValue);
        }
      });
    },
    gFormErrorFieldBehavior: function() {
      var gFieldSelector = '.gfield-material',
        inputSelector = '.gfield-material .medium';
      //hide validation messages on focus or keyup
      $(inputSelector).on('focus keyup change', function(e) {
        var input = $(this),
          value = input.val();
        input.parents(gFieldSelector).toggleClass('not-empty', (value.length > 0));
      });
    },
    gFormModalConfirmation: function() {
      $(document).on('gform_confirmation_loaded', function(event, formId) {
        var currentModal = $('#gformModal-'+formId);
        if (currentModal.length) {
          currentModal.addClass('on-confirmation');
          var successTitle = currentModal.attr('data-success-title'),
            title = currentModal.attr('data-title');
          if (successTitle) {
            currentModal.find('.modal-title').addClass('success-title').html(successTitle);
          }
          currentModal.one('hidden.bs.modal', function() {
            currentModal.removeClass('on-confirmation');
            currentModal.find('.modal-title').removeClass('success-title').html(title);
          });
        }
      });
    },
    setGformTextareaCustomScrollBar: function(targetContainer, force) {
      force = force || false;
      var targetTextarea = targetContainer.find('textarea');
      if (targetTextarea.length) {
        var targetTextareaLabel = targetContainer.find('.gform_textarea .gfield_label');
        Forms.setTextAreaCustomScrollBar(targetTextarea, targetTextareaLabel, force);
      }
    },
    setTextAreaCustomScrollBar: function(target, label, force) {
      force = force || false;
      var reserveScrollGup = 5;
      var targetStartHeight = target[0].clientHeight + reserveScrollGup;
      var wrapper = target.closest('.ginput_container');
      target.addClass('scrollbar-outer');
      if (force) {
        if (targetStartHeight < target[0].scrollHeight) {
          target.scrollbar({
            'onScroll': function(y) {
              if (y.scroll >= y.maxScroll - 10) {
                wrapper.addClass('no-gradient');
              } else {
                wrapper.removeClass('no-gradient');
              }
            }
          });
          label.addClass('on-scroll');
          target.addClass('has-scrollbar');
        }
      }
      target.on('keyup', function() {
        if (targetStartHeight < target[0].scrollHeight) {
          target.scrollbar({
            'onScroll': function(y) {
              if (y.scroll >= y.maxScroll - 10) {
                wrapper.addClass('no-gradient');
              } else {
                wrapper.removeClass('no-gradient');
              }
            }
          });
          label.addClass('on-scroll');
          target.addClass('has-scrollbar');
        } else {
          target.scrollbar('destroy');
          label.removeClass('on-scroll');
          target.removeClass('has-scrollbar');
        }
        target.focus();
      });
    },

    initPhoneInputs: function(telInput) {

      telInput.prop({'maxlength': 21, 'type': 'tel', 'placeholder': ''});

      var allowDropdown = true,
        autoPlaceholder = 'polite';
      if (Utils.detectTouchDevice()) {
        allowDropdown = false;
        autoPlaceholder = 'off';
      }

      telInput.intlTelInput({
        nationalMode: false,
        formatOnDisplay: true,
        initialCountry: 'RU',
        customPlaceholder: function(selectedCountryPlaceholder) {
          return selectedCountryPlaceholder.split(' ')[0];
        },
        preferredCountries: ['RU', 'UA', 'KZ', 'BY', 'AZ'],
        utilsScript: '/app/themes/letters/dist/scripts/utils.js',
        allowDropdown: allowDropdown,
        autoPlaceholder: autoPlaceholder
      });

      telInput.closest('.gfield').find('.flag-container').toggleClass('active', telInput.val().length > 0);

      telInput.on('input', function() {
        var self = $(this),
          value = self.val(),
          new_value = value.replace(/[^0-9 ]/g, '');
        new_value = '+' + new_value;
        if (value !== new_value) {
          self.val(new_value);
        }
      });

      telInput.on('keyup mouseup', resetIntlTelInput);
      function resetIntlTelInput() {
        if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
          var currentText = telInput.intlTelInput('getNumber', intlTelInputUtils.numberFormat.INTERNATIONAL);
          if (typeof currentText === 'string') { // sometimes the currentText is an object
            telInput.intlTelInput('setNumber', currentText);
          }
        }
      }
    },
    executeRecaptcha: function() {
      if ((typeof grecaptcha === 'object') &&
        (typeof gglcptch === 'object') &&
        (typeof gglcptch.options.sitekey !== 'undefined')) {
        grecaptcha.ready(function() {
          grecaptcha.execute(gglcptch.options.sitekey, {action: 'BWS_reCaptcha'}).then(function(token) {
            document.querySelectorAll('#g-recaptcha-response').forEach(function(elem) {
              elem.value = token;
            });
          });
        });
      }
    },

    gFormInit: function() {
      var materialinputSelector = '.gfield-material .medium';
      $(materialinputSelector).each(Forms.gFormMaterialLabelUp);
      $(document).on('keyup blur', materialinputSelector, Forms.gFormMaterialLabelUp);
      $(document).on('focus blur', materialinputSelector, Forms.gFormDelegateState);
      $(document).on('blur', '.country-list', Forms.gFormDelegateState);

      $('.gform-modal').on('shown.bs.modal', function() {
        Forms.setGformTextareaCustomScrollBar($(this));
      });

      Forms.gFormModalConfirmation();

      function gFormOtherBind() {
        $('.gravity-form form').on('submit', function() {
          var self = $(this);
          var btn = self.find('input[type="submit"], .englex-gform-submit, .englex22-gform-submit');
          btn.prop('disabled', 'disabled');
          if (!btn.parent().hasClass('gform_page_footer')) {
            btn.text('Отправляем...').val('Отправляем...');
          }
        });
        $('.callback-number').each(function() {
          Forms.initPhoneInputs($(this).find('input').first());
        });
        Forms.filterInputCharactersInit('.gfield.gfield-name .medium', Utils.nameRegexp);
        Forms.filterInputCharactersInit('.gfield textarea.medium', Utils.textareaRegexp);
        Forms.gFormErrorFieldBehavior();
      }
      gFormOtherBind();
      $(document).on('gform_post_render', function(e, form_id) {
        gFormOtherBind();
        $('.gravity-form').each(function() {
          Forms.setGformTextareaCustomScrollBar($(this), true);
        });
      });
    },
    initForms: function() {
      Forms.offFillEvents();
      Forms.gFormInit();
    },
  };

  var Cost = {
    getGiftAmountByCombinationString: function(combinationString, resultField) {
      if ((typeof cost_selector_block !== 'undefined') && (cost_selector_block.cost !== 'undefined') && cost_selector_block.cost.length) {
        var costs = JSON.parse(cost_selector_block.cost);
        if (typeof costs[combinationString] !== 'undefined') {
          return costs[combinationString][resultField];
        }
      }

      return 0;
    },
    initCostBlock: function(parentEl) {
      var groups = cost_selector_block.groups;
      var group_by = cost_selector_block.group_by;
      var types = cost_selector_block.types;
      var costs = cost_selector_block.cost.length ? JSON.parse(cost_selector_block.cost) : 0;

      // prepare combination
      var combination = {};
      $.each(types, function(index, value) {
        var tmp = parentEl.find('.cost-param-' + value);
        var defaultValue = tmp.attr('data-default');
        if (defaultValue) {
          tmp.val(defaultValue);
        }
        combination[value] = tmp.val();
      });

      parentEl.find('.cost-param').on('change', function() {
        if (!costs) {
          return;
        }
        var changedEl = $(this);
        var changedValue = changedEl.val();
        var changedDataType = changedEl.data('type');
        combination[changedDataType] = changedValue;

        var values = Object.keys(combination).map(function(key) {
          return combination[key];
        });
        var combinationString = values.join('_');
        if ('none' === group_by) {
          giftCalc(parentEl, combination);
        }
        $.each(groups, function(index, group) {
          if ('packages' === group_by) {
            packagesCalc(parentEl, combination, group);
          } else if ('tariffs' === group_by) {
            tariffsCalc(parentEl, combination, group);
          }
        });

        // update filter buttons selected classes
        parentEl.find('.cost-filter-' + changedDataType).removeClass('selected');
        parentEl.find('.cost-filter-' + changedDataType + '[value=\'' + changedValue+ '\']').addClass('selected');

        function packagesCalc(parentEl, combination, group) {
          var groupData = costs[group][combinationString];
          parentEl.find('.value-cost-' + group).text(groupData.cost);
          if (costs[group][combinationString].discount == 0) {
            parentEl.find('.value-discount-' + group).text('');
          } else {
            parentEl.find('.value-discount-' + group).html('<span class="discount-value">–' + groupData.discount + '%</span>');
          }
          parentEl.find('.value-package-cost-' + group).text(groupData.package_cost);
          parentEl.find('.value-sc-text-' + group).text(groupData.sc_text);
          if (Cost.campaignPricesEnabled(combination.speaker, combination.tarif)) {
            parentEl.find('.value-sc-text-campaign-' + group).text(groupData.campaign_sc_text);
            if (cost_selector_block.discount30_type == 'table') {
              parentEl.find('.value-discount-campaign-' + group).html(groupData.campaign_discount ? '–'+groupData.campaign_discount+'%' : '');
              parentEl.find('.value-package-cost-campaign-' + group).html(groupData.campaign_package_cost_text);
              parentEl.find('.value-cost-campaign-' + group).text(groupData.campaign_cost);
              parentEl.find('.package-'+group).toggleClass('package-no-discount', groupData.campaign_cost === groupData.cost);
            }
          } else {
            parentEl.find('.value-cost-campaign-' + group).text('');
            parentEl.find('.value-discount-campaign-' + group).text('');
            parentEl.find('.value-package-cost-campaign-' + group).text('');
          }
          parentEl.find('.package-'+group).toggleClass('disabled', groupData.is_disabled);

          var popoverContent = parentEl.find('.speaking-club-popover-content');
          popoverContent.find('.sc-title').html(groupData.sc_popover_title);
          popoverContent.find('.sc-description').html(groupData.sc_popover_text);
        }
        function tariffsCalc(parentEl, combination, value) {
          var costData = costs[value][combinationString];
          parentEl.attr('data-duration', combination.duration).attr('data-package', combination.package);
          var price = costData.cost;
          var crossedPrice = '';
          var discount = costData.discount ? costData.discount : '';
          var packagePrice = costData.package_cost;
          var crossedPackagePrice = '';
          if (Cost.campaignPricesEnabled(combination.speaker, value)) {
            if (cost_selector_block.discount30_type === 'table') {
              if ((+costData.max_cost > +costData.campaign_cost) && costData.campaign_cost && costData.campaign_discount && costData.campaign_package_cost) {
                price = costData.campaign_cost;
                discount = costData.campaign_discount;
                packagePrice = costData.campaign_package_cost;
              }
            }
          }
          if (+costData.max_cost > price) {
            crossedPrice = costData.max_cost;
            crossedPackagePrice = costData.max_package_cost;
          }

          parentEl.find('.value-price-'+value).text(price ? price + ' ₽' : '');
          parentEl.find('.value-crossed-price-'+value).text(crossedPrice ? crossedPrice + ' ₽' : '');
          parentEl.find('.value-discount-'+value).text(discount ? '−' + discount + '%' : '');
          parentEl.find('.value-package-price-'+value).text(packagePrice ? packagePrice + ' ₽' : '');
          parentEl.find('.value-crossed-package-price-'+value).text(crossedPackagePrice ? crossedPackagePrice + ' ₽' : '');

          if (cost_selector_block.gift_lessons) {
            var gift = cost_selector_block.gift_lessons[$('.cost-param-package').val()] || '';
            parentEl.find('.value-gift-lessons').html(gift);
          }
        }
        function giftCalc(parentEl) {
          if (cost_selector_block.gift_cert_discount_active) {
            $('#gift-cost-result').html(costs[combinationString].discount_package_cost_formatted + Utils.ruble);

            $('#gift-cost-result-discount-value').text(costs[combinationString].discount);
            $('#gift-cost-result-linethrough').html(costs[combinationString].package_cost_crossed_formatted + Utils.ruble);
            $('.gift-discount-col').toggleClass('package-no-discount', costs[combinationString].no_crossed_price);

            // duration buttons discount labels
            var tmpCombination = {};
            $.each(types, function(index, value) {
              tmpCombination[value] = parentEl.find('.' + value).val();
            });
            $('.cost-filter-package').each(function() {
              var packageBtn = $(this);
              tmpCombination.package = packageBtn.val();
              var tmpValues = Object.keys(tmpCombination).map(function(key) {
                return tmpCombination[key];
              });
              var tmpCombinationString = tmpValues.join('_');
              $('#package-'+packageBtn.val()+'-discount-value').text(costs[tmpCombinationString].discount);
              packageBtn.parent().find('.package-discount-label').toggleClass('d-none', (costs[tmpCombinationString].discount === '0'));
            });
          } else {
            $('#gift-cost-result').html(costs[combinationString].package_cost_formatted + Utils.ruble);
          }
        }
      });
    },
    campaignPricesEnabled: function(speaker, tarif) {
      var result = false;
      if (cost_selector_block.discount30_active && (speaker != 'native' || cost_selector_block.discount30_for_native)) {
        result = true;
      }
      return result;
    },
    initCostPage: function() {
      Cost.initCostBlock($('.cost-table-wrapper'));

      if (!Utils.isMobile()) {
        $('select.cost-param').select2({
          minimumResultsForSearch: -1,
          width: 'style',
          templateResult: function(result) {
            return Utils.commonSelectOption(result);
          },
          dropdownCssClass: cost_selector_block.dropdownCssClass,
          containerCssClass: cost_selector_block.containerCssClass,
        });
      }
      $('.packages-select-desktop').select2({
        minimumResultsForSearch: -1,
        width: 'style',
        data: discount_select2_data.data,
        escapeMarkup: function(markup) {
          return markup;
        },
        dropdownCssClass: cost_selector_block.dropdownCssClass,
        containerCssClass: cost_selector_block.containerCssClass,
      });

      $(document).on('change', '.packages-select-mobile', function() {
        var otherSelect = $('.packages-select-desktop');
        var changedVal = $(this).val();
        if (changedVal && (otherSelect.val() !== changedVal)) {
          otherSelect.val(changedVal).trigger('change');
        }
      }).on('change', '.packages-select-desktop', function() {
        var otherSelect = $('.packages-select-mobile');
        var changedVal = $(this).val();
        if (changedVal && (otherSelect.val() !== changedVal)) {
          otherSelect.val(changedVal).trigger('change');
        }
      });
      $('.packages-select-mobile').trigger('change');

      var tariffsSlider = $('.tariffs-slider');
      if (!global_settings.isNewStyle) {
        tariffsSlider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          prevArrow: $('.slick-tariffs-prev'),
          nextArrow: $('.slick-tariffs-next'),
          infinite: false,
          variableWidth: true,
          touchThreshold: 20,
          responsive: [
            {
              breakpoint: Utils.bootstrapGrid.md,
              settings: {
                slidesToShow: 1,
                centerMode: true,
              },
            },
          ],
        });
      } else {
        tariffsSlider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          prevArrow: $('.slick-tariffs-prev'),
          nextArrow: $('.slick-tariffs-next'),
          infinite: false,
          variableWidth: true,
          touchThreshold: 20,
          responsive: [
            {
              breakpoint: Utils.bootstrapGrid.xl,
              settings: {
                slidesToShow: 2,
                dots: false,
                arrows: true,
              },
            },
            {
              breakpoint: Utils.bootstrapGrid.lg,
              settings: {
                slidesToShow: 1,
                dots: false,
                arrows: true,
              },
            },
            {
              breakpoint: Utils.bootstrapGrid.md,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                dots: true,
              },
            },
          ],
        });
      }
      tariffsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('[data-toggle="popover"]').popover('hide');
      });
      var selectorValues = {
        duration: {
          param: 'duration',
          value: ''
        },
        speaker: {
          param: 'speaker',
          value: ''
        },
        course: {
          param: 'course_id',
          value: ''
        },
      };
      for (var key in selectorValues) {
        var selectorUrlParamName = selectorValues[key].param,
          selectorValue = Utils.getUrlParameter(selectorUrlParamName);
        selectorValues[key].value = selectorValue;
        if (selectorValue) {
          $('.cost-select.'+key).find('option[data-'+selectorUrlParamName+'='+selectorValue+']').prop('selected', true);
          $('.cost-select.'+key).trigger('change');
        }
      }

      Utils.initTabsToggleSelect('.nav-tabs-mobile', '.payments-navigation', '.tabs-list-link');
      $('.nav-tabs-mobile').val('bank-card').trigger('change');

      Blocks.questionsBlock();

      $('.discount-wrapper .campaign-link').on('click', function() {
        $('#campaignModal').modal('show');
      });
    },
  };

  var Blocks = {
    /**
     * Menus
     */
    initMobileMenu: function() {
      var bodyScroll;
      $('.mobile-menu-open').on('click', function() {
        $('.mobile-menu').fadeIn();
        bodyScroll = $(window).scrollTop();
        $('body').addClass('modal-open').css({
          marginTop: -bodyScroll ,
          position: 'fixed',
          width: '100%',
          height: '100%'
        });
      });
      $('.mobile-menu-close').on('click', function(e) {
        closeMenu(bodyScroll);
      });
      mobileMenuHeaderBehavior();

      // anchors
      $('.mobile-menu .scroll-to-anchor a').on('click', function(e) {
        e.preventDefault();
        closeMenu(bodyScroll);
        scrollToAnchor($(this));
      });
      $('.header-menu-wrapper .scroll-to-anchor a').on('click', function(e) {
        e.preventDefault();
        scrollToAnchor($(this));
      });

      function scrollToAnchor(linkEl) {
        var link = linkEl.attr('href'),
          target = $(link);
          $('body,html').animate({scrollTop: target.offset().top}, 500, 'swing', function() {
            $('body,html').animate({scrollTop: target.offset().top}, 100, function() {
              $(document).trigger('finishAnchorScroll');
            });
          });

        linkEl.blur();
      }
      function closeMenu(bodyScroll) {
        $('.mobile-menu').fadeOut();
        $('body').removeClass('modal-open').removeAttr('style');
        window.scrollTo(0, bodyScroll);
      }
      function mobileMenuHeaderBehavior() {
        var scrollTimeout,
          header = $('.mobile-menu-header'),
          switchOnHeight = 62,
          throttle = 100,
          scrollElement = $('.mobile-menu'),
          headerBehaviorOnScroll = function() {
            var currentScrollTop = scrollElement.scrollTop(),
              staticHeader = (currentScrollTop < switchOnHeight);
            header.toggleClass('has-shadow', !staticHeader);
          };
        scrollElement.on('scroll', function() {
          if (!scrollTimeout) {
            scrollTimeout = setTimeout(function() {
              headerBehaviorOnScroll();
              scrollTimeout = null;
            }, throttle);
          }
        });
      }
    },
    accordionMenuAnimatedInit: function(menuElementSelector, disableAutoClose) {
      disableAutoClose = disableAutoClose || false;
      var menuLinkSelector = menuElementSelector + '> a',
        allMenuElements = $(menuElementSelector),
        menuLink = $(menuLinkSelector),
        activeMenuElementClass = 'active';
      menuLink.on('click', function(e) {
        e.preventDefault();
        var menuElement = $(this).parent();
        if (menuElement.hasClass(activeMenuElementClass)) {
          menuElement.find('.sub-menu').slideUp();
          menuElement.removeClass(activeMenuElementClass);
        } else {
          if (!disableAutoClose) {
            allMenuElements.find('.sub-menu').slideUp();
            allMenuElements.removeClass(activeMenuElementClass);
          }
          menuElement.find('.sub-menu').slideDown();
          menuElement.addClass(activeMenuElementClass);
        }
      });
    },
    initMenus: function() {
      var linkSelector = ' .menu-item-has-children > .header-nav-link';
      var menuItemWithChildrenSelector = ' .menu-item-has-children';
      var links = $(Utils.fixedMenuSelector + linkSelector + ', ' + Utils.usualMenuSelector + linkSelector);
      var menuItemsWithChildren = $(Utils.fixedMenuSelector + menuItemWithChildrenSelector + ', ' + Utils.usualMenuSelector + menuItemWithChildrenSelector);

      function closeAllSubMenu() {
        menuItemsWithChildren.find('.sub-menu').removeClass('open onhover').css({opacity: ''});
      }

      if (!Utils.isTouch) {
        // show submenu on menu-item hover
        links.on('mouseenter', function() {
          closeAllSubMenu();
          var subMenu = $(this).siblings('.sub-menu');
          if (!subMenu.hasClass('onhover')) {
            subMenu.addClass('open');
          }
        });
      }
      // submenu behavior on menu-item click
      links.on('click', function(e) {
        var self = $(this),
          subMenu = self.siblings('.sub-menu');

        var hasOpenClass = subMenu.hasClass('open');

        if (Utils.isTouch) {
          e.preventDefault();
          closeAllSubMenu();
          subMenu.removeClass('onhover');
          subMenu.toggleClass('open', !hasOpenClass);
        } else {
          var link = self.attr('href');
          if (link === '#') {
            e.preventDefault();
          }
        }
      });

      // delay before closing dropdown menu
      links.on('mouseenter', function() {
        var subMenu = $(this).parent().find('.sub-menu');
        subMenu.addClass('onhover').stop(true);
      });
      menuItemsWithChildren.on('mouseleave', function() {
        var subMenu = $(this).find('.sub-menu');
        if (subMenu.hasClass('open')) {
          subMenu.addClass('onhover').removeClass('open').animate({opacity: 1}, 100, function() {
            $(this).removeClass('onhover').css({opacity: ''});
          });
        }
      });

      function setSubmenuMaxHeight() {
        if ($(window).width() >= Utils.bootstrapGrid.xl) {
          $(Utils.fixedMenuSelector + ' .fixed-menu-container ' + global_settings.header_sticky_dropdown_item_parent_selector).each(function(index) {
            var self = $(this);
            var submenu = self.find(global_settings.header_sticky_dropdown_selector + ' .dropdown-menu-inner');
            var submenuMaxHeight = $(window).height() - 70;
            submenu.css({
              'maxHeight': submenuMaxHeight+'px',
              'overflow': 'auto',
            });
          });
        }
      }
      setSubmenuMaxHeight();
      $(window).on('resize', function(){
        setSubmenuMaxHeight();
      });

      //Blocks.mobileMenuInit();
      //Blocks.footerAccordionMenuInit();
    },

    /**
     * Buttons
     */
    initSignupParamsBtn: function() {
      var params = [
        't_s_t_name',
        'course',
        'teacher_name',
        'teacher_url',
        'tariff',
      ];
      $('.signup-modal-params').on('click', function() {
        var self = $(this);
        params.forEach(function(param) {
          Utils.setCookie(param, (self.attr('data-'+param) || ''), 1);
        });
      });
      $('#gformModal-' + global_settings.gform_submit_ID).on('hidden.bs.modal', function() {
        params.forEach(function(param) {
          Utils.setCookie(param, '', 1);
        });
      });
    },

    /**
     * Blocks
     */
    questionsBlock: function() {
      // Toggle shadows on opened/closed questions
      $('.details-wrapper').on('show.bs.collapse hide.bs.collapse', function(event) {
        ($(this)).parent().toggleClass('shadow', 'show' === event.type);
      });

      // Set question clickable area height
      $('.question').on('click', function(event) {
        var self = $(this);
        if (self.hasClass('collapsed')) {
          var height = self.parent().innerHeight();
          self.css('height', height + 'px');
        }
      });
    },
    reviewsBlock: function() {
      var wrapper = $('.reviews-block-wrapper'),
        type = wrapper.attr('data-type');

      wrapper.find('.card-deck').slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        nextArrow: '.slick-reviews-next',
        prevArrow: '.slick-reviews-prev',
        variableWidth: true,
        initialSlide: 0,
        centerMode: false,
        touchThreshold: 20,
        responsive: [
          {
            breakpoint: Utils.bootstrapGrid.sm,
            settings: {
              centerMode: true,
            }
          },
        ]
      });

      $('.testimonial-slide').each(function() {
        var card = $(this),
          textBlock = card.find('.text-wrapper'),
          titleBlock = card.find('.card-title');
        setTextClamp(textBlock, titleBlock);
        $(document).on('changeWidth', function(e, windowWidth) {
          setTextClamp(textBlock, titleBlock);
        });
      });

      function setTextClamp(textBlock, titleBlock) {
        var titleLines = Math.round(titleBlock.height() / +titleBlock.css('lineHeight').replace('px',''));
        var lines = {
          1: 7,
          2: 6,
          3: 5,
        };
        var newTextClass = 'lclamp-'+(lines[titleLines] || 4);
        textBlock.removeClass('lclamp-5 lclamp-6 lclamp-7').addClass(newTextClass);
      }

      setTimeout(function () {
        wrapper.find('.card-deck').slick('setPosition');
      }, 500);
    },
    reviewModal: function(action) {
      action = action || 'lttrs_get_review_modal';
      var getReviewModalButton = $('.get-review-modal');
      getReviewModalButton.off('click');
      getReviewModalButton.on('click', function(e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) {
          return;
        }
        getReviewModalButton.addClass('disabled');
        var review_id = $(this).data('modal-id');
        var reviewModal = $('#reviewModal');
        $.ajax({
          type: 'GET',
          url: resources_ajax.ajax_url,
          data: 'action=' + action + '&review_id=' + review_id,
          datatype: 'html',
          success: function(data) {
            var selector = '.review-content';
            reviewModal.find(selector).html(data);
            reviewModal.modal('show');
            Utils.addCustomScrollBar($('#reviewModal .modal-text'));
            getReviewModalButton.removeClass('disabled');
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
          }
        });
        return false;
      });
    },
    tabsBlock: function() {
      $('.tabs-block').each (function() {
        var tabsBlock = $(this);
        var menuSlider = tabsBlock.find('.tabs-menu');
        var contentSlider = tabsBlock.find('.tabs-content');
        menuSlider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          swipeToSlide: true,
          arrows: false,
          dots: false,
          touchThreshold: 100,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 1020,
              settings: {
                slidesToShow: 1,
                centerMode: false,
                asNavFor: contentSlider,
              }
            },
          ]
        });
        contentSlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          touchThreshold: 100,
          arrows: false,
          dots: false,
          swipe: false,
          swipeToSlide: false,
          touchMove: false,
          variableWidth: false,
          fade: true,
          speed: 0,
          responsive: [
            {
              breakpoint: 1020,
              settings: {
                slidesToShow: 1,
                centerMode: false,
                swipe: true,
                swipeToSlide: true,
                touchMove: true,
                variableWidth: true,
                fade: false,
                speed: 300,
                asNavFor: menuSlider,
              }
            },
          ]
        });
        tabsBlock.find('.tabs-menu-item').on('click', function() {
          var clicked = $(this);
          contentSlider.slick('slickGoTo', clicked.closest('.tabs-menu-slide').attr('data-slick-index'));
          tabsBlock.find('.tabs-menu-item').removeClass('active');
          clicked.addClass('active');
        });
      });
    },
    frontPageCostBlock: function() {
      Cost.initCostBlock($('.cost-section'));
      setTimeout(function() {
        //if (!Utils.isMobile()) {
          $('select'+cost_selector_block.selectSelector).select2({
            minimumResultsForSearch: -1,
            width: 'style',
            templateResult: function(result) {
              return Utils.commonSelectOption(result);
            },
            dropdownCssClass: cost_selector_block.dropdownCssClass,
            containerCssClass: cost_selector_block.containerCssClass,
          });
        //}
        $('.packages-select-desktop').select2({
          minimumResultsForSearch: -1,
          width: 'style',
          data: discount_select2_data.data,
          escapeMarkup: function(markup) {
            return markup;
          },
          dropdownCssClass: cost_selector_block.dropdownCssClass,
          containerCssClass: cost_selector_block.containerCssClass,
        });
        $(document).on('change', '.packages-select-mobile', function() {
          var otherSelect = $('.packages-select-desktop');
          var changedVal = $(this).val();
          if (changedVal && (otherSelect.val() !== changedVal)) {
            otherSelect.val(changedVal).trigger('change');
          }
        }).on('change', '.packages-select-desktop', function() {
          var otherSelect = $('.packages-select-mobile');
          var changedVal = $(this).val();
          if (changedVal && (otherSelect.val() !== changedVal)) {
            otherSelect.val(changedVal).trigger('change');
          }
        });
        $('.cost-select.package').trigger('change');
      }, 10);

      $('.tariffs-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $('.slick-tariffs-prev'),
        nextArrow: $('.slick-tariffs-next'),
        infinite: false,
        variableWidth: true,
        touchThreshold: 20,
        responsive: [
          {
            breakpoint: Utils.bootstrapGrid.xl,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: Utils.bootstrapGrid.md,
            settings: {
              slidesToShow: 1,
              dots: true,
              centerMode: true,
            },
          },
        ],
      });
    },
    ncsTariffsBlock: function() {
      var block = $('.ncs-tariffs-block .other-courses-card');
      if (!block.length) {
        return;
      }
      ncsCost.tariffsCostBlockNcs(block, cost_selector_block_ncs_adaptive);

      $('select.cost-param').select2({
        minimumResultsForSearch: -1,
        width: 'style',
        templateResult: function (result) {
          return Utils.commonSelectOption(result);
        },
        dropdownCssClass: 'ncs-select2-dropdown',
        containerCssClass: 'ncs-select2-container'
      });

      $('.packages-select-desktop').select2({
        minimumResultsForSearch: -1,
        width: 'style',
        data: discount_select2_ncs.data,
        escapeMarkup: function (markup) {
          return markup;
        },
        dropdownCssClass: 'ncs-select2-dropdown',
        containerCssClass: 'ncs-select2-container'
      });

      $(document).on('change', '.packages-select-mobile', function() {
        var otherSelect = $('.packages-select-desktop');
        var changedVal = $(this).val();
        if (changedVal && (otherSelect.val() !== changedVal)) {
          otherSelect.val(changedVal).trigger('change');
        }
      }).on('change', '.packages-select-desktop', function() {
        var otherSelect = $('.packages-select-mobile');
        var changedVal = $(this).val();
        if (changedVal && (otherSelect.val() !== changedVal)) {
          otherSelect.val(changedVal).trigger('change');
        }
      });

      $('.packages-select-mobile').trigger('change');
    },
    ncsTariffCardsBlock: function() {
      var block = $('.ncs-tariff-cards-block');
      if (block.length) {

        var durationSelect = block.find('select.cost-param-duration');
        if (durationSelect.length) {
          durationSelect.select2({
            minimumResultsForSearch: -1,
            width: 'style',
            escapeMarkup: function(markup) {
              return markup;
            },
            dropdownCssClass: 'ncs-select2-dropdown',
            containerCssClass: 'ncs-select2-container'
          });
        }

        ncsCost.tariffsCostBlockNcs(block, cost_selector_block_ncs_cards);

        var withColumns = block.hasClass('with-columns');
        var slider = $('.ncs-tariff-cards-block .price-cards');
        slider.slick({
          infinite: false,
          arrows: true,
          prevArrow: $('.slick-price-cards-prev'),
          nextArrow: $('.slick-price-cards-next'),
          slidesToShow: withColumns ? 2 : 3,
          slidesToScroll: 1,
          variableWidth: true,
          touchThreshold: 20,
          responsive: [
            {
              breakpoint: Utils.bootstrapGrid.xl,
              settings: {
                slidesToShow: withColumns ? 1 : 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: Utils.bootstrapGrid.lg,
              settings: {
                slidesToShow: withColumns ? 1 : 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: Utils.bootstrapGrid.md,
              settings: {
                variableWidth: true,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: Utils.bootstrapGrid.sm,
              settings: {
                //centerMode: true,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
          ]
        });
        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          slider.find('[data-toggle="popover"]').popover('hide');
        });
      }
    }
  };

  var Utils = {
    bootstrapGrid: {
      xl: 1200,
      lg: 992,
      md: 768,
      sm: 576,
    },
    nameRegexp: /[^A-Za-zА-Яа-яЁё0-9- ]/g,
    textareaRegexp:  /[^A-Za-zА-Яа-яЁё0-9- ,.;?!@"'№$%:*()_=+\r\n]/g,

    commonSelectOption: function(result) {
      var element = $('<span>');
      element.text(result.text).addClass($(result.element).attr('class')).addClass('select-option');

      if ('undefined' != typeof((result.element)) && $(result.element).is(':selected')) {
        element.addClass('selected');
      }
      return element;
    },
    commonSelectContainerClass: 'common-select2-container',
    commonSelectDropdownClass: 'common-select2-dropdown',
    initTabsWithSelect: function(selectEl, items) {
      selectEl.on('change', function() {
        var valueSelected = this.value;
        var targetTab = '#' + valueSelected;
        $('a[href="' + targetTab + '"]').tab('show');
      });
      items.on('click', function() {
        var btnTabName = $(this).attr('href');
        if (btnTabName) {
          var targetFilterValue = btnTabName.replace('#', '');
          selectEl.val(targetFilterValue).trigger('change');
        }
      });
      selectEl.trigger('change');
    },
    initTabsToggleSelect: function(tabsSelectSelector, tabLinksContainerSelector, tabLinkSelector) {
      var tabsSelect = $(tabsSelectSelector);

      if (!Utils.isMobile()) {
        tabsSelect.select2({
          minimumResultsForSearch: -1,
          width: 'style',
          dropdownCssClass: 'select2-dropdown-menu',
          containerCssClass: 'select2-dropdown-menu-container',
        });
      }

      Utils.initTabsWithSelect(tabsSelect, $(tabLinksContainerSelector + ' ' + tabLinkSelector));
    },

    initPopovers: function() {
      $("[data-toggle=popover]").popover();
    },

    setYouTubeVideo: function(callback) {
      callback = callback || function(clickedElement) {};
      var players = [];
      $(document).on('click', '.youtube-image-block, .play-button', function() {
        callback($(this));
        var currentElement = $(this);
        var iframe = document.createElement("iframe");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("width", currentElement.data('width'));
        iframe.setAttribute("height", currentElement.data('height'));
        iframe.setAttribute("src", "https://www.youtube.com/embed/" + currentElement.data('embed') + "?rel=0&showinfo=0&autoplay=1&enablejsapi=1");
        if (currentElement.hasClass('play-button')) {
          currentElement.parent('.youtube-image-block').append(iframe);
          currentElement.remove();
        } else {
          currentElement.append(iframe);
          currentElement.find('.play-button').remove();
        }
        var new_id = 'player_' + players.length;
        iframe.id = new_id;
        players.push((new YT.Player(new_id, {
          videoId: currentElement.data('embed'),
          playerVars: {'origin': global_settings.home_url },
          events: {
            'onStateChange': function(event) {
              if (event.data === YT.PlayerState.PLAYING) {
                $.each(players, function(k, v) {
                  if (this.getPlayerState() === YT.PlayerState.PLAYING && this.getIframe().id !== event.target.getIframe().id) {
                    this.pauseVideo();
                  }
                });
              }
            }
          }
        })));
        return false;
      });
      $(document).on('show.bs.modal', function() {
        $.each(players, function(k, v) {
          this.pauseVideo();
        });
      });
    },

    isMobile: function() {
      var $window = $(window);
      return Utils.detectTouchDevice() && (($window.width() < 768) && ($window.height() < 576));
    },
    detectTouchDevice: function() {
      var ifSmScreen = window.screen.availWidth < Utils.bootstrapGrid.lg;
      return ifSmScreen || 'ontouchstart' in window || navigator.maxTouchPoints;
    },

    getUrlParameter: function(sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1));
      var sURLVariables = sPageURL.split('&');
      var sParameterName;
      for (var i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    },
    parseQuery: function(url) {
      var params = {}, queries, temp, i, l;
      queries = url.split('&');

      for (i = 0, l = queries.length; i < l; i++) {
        temp = queries[i].split('=');
        params[temp[0]] = temp[1];
      }
      return params;
    },

    setSessionCookie: function(name, value) {
      document.cookie = name + "=" + value;
    },
    setCookie: function(name, value, days) {
      var expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + days);
      document.cookie = name+'='+value+'; expires='+ expiryDate.toUTCString() +'; path=/';
    },
    getCookie: function(name) {
      var cookieValue;
      return (cookieValue = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)")) ? cookieValue[2] : "";
    },
    setCPACookies: function() {
      var request = window.location.search;
      if (request.length) {
        var getParams = Utils.parseQuery(request.substring(1));
        if (isGetParamNotEmpty('admitad_uid', getParams)) {
          Utils.setCookie('admitad_uid', getParams.admitad_uid, 90);
          if (isGetParamNotEmpty('utm_campaign', getParams)) {
            Utils.setCookie('admitad_webmaster_uid', getParams.utm_campaign, 90);
          }
          clearAdvcakeCookies();
          clearEdPartnersCookies();
        }
        if (isGetParamEqual('utm_source', 'advcake', getParams)) {
          Utils.setCookie('advcake_enabled', 1, 30);
          clearAdmitadCookies();
          clearEdPartnersCookies();
        }
        if (isEdPartners(getParams)) {
          Utils.setCookie('ed_partners_cl_uid', getParams.cl_uid, 90);
          clearAdvcakeCookies();
          clearAdmitadCookies();
        }
        if (isGetParamNotEqual('utm_source', 'edpartners', getParams)) {
          clearEdPartnersCookies();
        }
      }

      function isGetParamNotEqual(param, value, getParams) {
        return (getParams[param] !== undefined) && (getParams[param] !== value);
      }
      function isGetParamEqual(param, value, getParams) {
        return (getParams[param] !== undefined) && (getParams[param] === value);
      }
      function isGetParamNotEmpty(param, getParams) {
        return (getParams[param] !== undefined) && (getParams[param]);
      }
      function isEdPartners(getParams) {
        return isGetParamEqual('utm_source', 'edpartners', getParams) &&
            isGetParamEqual('utm_campaign', 'affiliate', getParams) &&
            isGetParamEqual('utm_medium', 'cpa', getParams) &&
            isGetParamNotEmpty('cl_uid', getParams);
      }
      function clearAdvcakeCookies() {
        Utils.setCookie('advcake_enabled', '', -1);
        Utils.setCookie('advcake_track_id', '', -1);
        Utils.setCookie('advcake_track_url', '', -1);
      }
      function clearAdmitadCookies() {
        Utils.setCookie('admitad_uid', '', -1);
        Utils.setCookie('admitad_webmaster_uid', '', -1);
      }
      function clearEdPartnersCookies() {
        Utils.setCookie('ed_partners_cl_uid', '', -1);
      }
    },
    setUTMCookies: function() {
      var request = window.location.search;
      if (request.length) {
        var getParams = Utils.parseQuery(request.substring(1));
        var utmNames = [
          'utm_source',
          'utm_medium',
          'utm_campaign',
          'utm_content',
          'utm_term',
          'utm_referrer'
        ];
        for (i = 0; i < utmNames.length; i++) {
          var utmName = utmNames[i];
          if ((getParams[utmName] !== undefined) && (getParams[utmName])) {
            clearAndSetUtmCookies();
            break;
          }
        }
      }

      function clearAndSetUtmCookies() {
        for (i = 0; i < utmNames.length; i++) {
          var utmName = utmNames[i];
          var utmCookieName = 'pc_' + utmName;
          if ((getParams[utmName] !== undefined) && (getParams[utmName])) {
            Utils.setCookie(utmCookieName, getParams[utmName], 30);
          } else {
            Utils.setCookie(utmCookieName, '', -1);
          }
        }
      }
    },

    needCookiesAgreement: function() {
      if (typeof cookiesAgreementDataBlock !== 'undefined' && cookiesAgreementDataBlock.active) {
        if (!Utils.getCookie(cookiesAgreementDataBlock.cookie_name)) {
          return true;
        } else {
          return false;
        }
      }
    },
    showCookiesAgreement: function() {
      if (typeof cookiesAgreementDataBlock !== 'undefined') {
        var template;
        if (Utils.needCookiesAgreement()) {
          template = '<div class="cookies-agreement-wrapper" >' +
            '<span class="text-wrapper">' + cookiesAgreementDataBlock.text22 + '</span>' +
            '<span class="cookies-agreement-btn">' + cookiesAgreementDataBlock.btn_text22 + '</span>' +
            '</div>';
          $('body').prepend(template);
          $(document).on('click', '.cookies-agreement-wrapper .cookies-agreement-btn', function() {
            $(this).closest('.cookies-agreement-wrapper').remove();
            Utils.setCookie(cookiesAgreementDataBlock.cookie_name, 'true', +cookiesAgreementDataBlock.cookie_expiration_days);
          });
          $(document).on('click', '.cookies-agreement-wrapper .btn-close', function() {
            $(this).closest('.cookies-agreement-wrapper').remove();
          });
        }
      }
    },

    redirectOnSuccessfulSubscribe: function(url) {
      window.location = url;
    },

    reachGoal: function(target_name, sent_callback, unsent_callback) {
      sent_callback = sent_callback || function() {};
      unsent_callback = unsent_callback || function() {};
      var yaCounter = window.yaCounter96109696;

      if (Utils.canSendGoals() && yaCounter) {
        yaCounter.reachGoal(target_name, function() {
          if (global_settings.reachgoal_debug_alerts) {
            alert('ym sent goal '+ target_name);
          }
          sent_callback();
        });
      } else {
        unsent_callback();
      }
    },
    canSendGoals: function() {
      return global_settings.use_analytics && global_settings.can_send_goals;
    },

    initChangeWidthEvent: function() {
      var $window = $(window),
        windowWidth = $window.width();
      $window.resize(function() {
        if ($window.width() !== windowWidth) {
          windowWidth = $window.width();
          $(document).trigger('changeWidth', windowWidth);
        }
      });
    },

    addCustomScrollBar: function(modalBody) {
      modalBody.addClass('scrollbar-outer');
      modalBody.scrollbar({
        'autoScrollSize': true,
        'onFallback': function(y) {
          var wrapper = y.parent();
          wrapper.addClass('no-custom-scrollbar');
        },
        'onScroll': function(y) {
          var wrapper = modalBody.closest('.scrolled-content-wrapper');
          var gradientBlock = wrapper.find('.dynamic-gradient');
          var gradientBlockTop = wrapper.find('.dynamic-gradient-top');
          var gradientBlockBottom = wrapper.find('.dynamic-gradient-bottom');
          gradientBlock.toggleClass('invisible', (y.scroll === y.maxScroll));
          gradientBlockBottom.toggleClass('invisible', (y.scroll >= y.maxScroll - 20));
          gradientBlockTop.toggleClass('invisible', (y.scroll <= 0));
        }
      });
    },

    commonScripts: function() {
      Forms.initForms();
      Blocks.initMenus();
      Utils.showCookiesAgreement();
      Utils.setCPACookies();
      Utils.setUTMCookies();
      Utils.initPopovers();

      Forms.initSubscribeForm();
      Forms.initCustomSignupForm();
      Forms.initContactOrRecallForm();

      // Focus on first input in modal
      $('.modal').on('shown.bs.modal', function() {
        var modal = $(this);
        if (!modal.hasClass('no-focus') && !(Utils.detectTouchDevice())) {
          modal.find('input').first().focus();
        }
      });

      //custom ym goals
      $(document).on('click', 'a[data-reachgoal]', function(e) {
        var self = $(this);
        var url = self.attr('href');
        var goal = self.attr('data-reachgoal');
        var link_action = function() {
          document.location.href = url;
        };
        if (self.attr('target') !== '_blank') {
          e.preventDefault();
          Utils.reachGoal(goal, link_action, link_action);
        } else {
          Utils.reachGoal(goal);
        }
      });
      $(document).on('click', 'button[data-reachgoal]', function() {
        var self = $(this);
        var goal = self.attr('data-reachgoal');
        Utils.reachGoal(goal);
      });

      Banners.init();
      Banners.customStb();
      Notify.init();

      $(document).on('mouseenter', '.select2-selection__rendered', function () {
        $('.select2-selection__rendered').removeAttr('title');
      });

      Utils.initChangeWidthEvent();
      Blocks.initSignupParamsBtn();
      Blocks.accordionMenuAnimatedInit('.mobile-accordion-menu .menu-item-has-children', true);
      Blocks.initMobileMenu();

      $('.up-button').on('click', function () {
        $('body, html').animate({
          scrollTop: 0
        }, 2000);
      });

      // show signup modal
      var param = Utils.getUrlParameter('show');
      if ((param === 'signup')) {
        $('.signup-modal').modal('show');
      }
    },
  };

  var Notify = {
    /**
     * Init PNotify
     */
    init: function () {
      PNotify.styling.modern = {
        container: 'alert',
        notice: 'alert-warning',
        notice_icon: 'i i-exclamation-circle',
        info: 'alert-info',
        info_icon: 'i i-info',
        success: 'alert-success',
        success_icon: 'i i-check',
        error: 'alert-danger',
        error_icon: 'i i-warning',
        closer: 'i i-times',
        pin_up: 'i i-pause',
        pin_down: 'i i-play'
      };
      PNotify.prototype.options.buttons.sticker = false;
      PNotify.prototype.options = $.extend(PNotify.prototype.options, {
        styling: 'modern',
        addclass: 'modern',
        insert_brs: false,
        delay: 8000,
        hide: false,
        stack: {
          "dir1": 'down',
          "dir2": 'left',
          "push": 'bottom',
          "spacing1": 15,
          "spacing2": 15,
          "firstpos1": 84,
          "firstpos2": 15,
          "context": $('body'),
          "modal": false
        }
      });
    },

    /**
     * Shows notification via PNotify
     *
     * @param type
     * @param text
     * @param title
     * @param options
     */
    _show: function (type, text, title, options) {
      if ($.isPlainObject(text)) {
        options = text;
        options.type = type;
      } else {
        options = $.extend(options, {
          type: type,
          text: text,
          title: title
        });
      }
      new PNotify(options);
    },

    /**
     * Success notification
     *
     * @param text
     * @param title
     * @param options
     */
    success: function (text, title, options) {
      Notify._show('success', text, title, $.extend({hide: true}, options));
    },

    /**
     * Error notification
     *
     * @param text
     * @param title
     * @param options
     */
    error: function (text, title, options) {
      Notify._show('error', text, title, options);
    },

    /**
     * Info notification
     *
     * @param text
     * @param title
     * @param options
     */
    info: function (text, title, options) {
      Notify._show('info', text, title, options);
    },

    /**
     * Warning notification
     * @param text
     * @param title
     * @param options
     */
    warning: function (text, title, options) {
      Notify._show('warning', text, title, options);
    }
  };

  var ncsCost = {
    tariffsCostBlockNcs: function(parentEl, dataBlock) {
      var costs = dataBlock.cost;
      var types = dataBlock.types;
      var groupBy = dataBlock.groupBy;

      // prepare combination
      var combination = {};
      $.each(types, function(index, value) {
        var tmp = parentEl.find('.cost-param-' + value);
        var defaultValue = tmp.attr('data-default');
        if (defaultValue) {
          tmp.val(defaultValue);
        }
        combination[value] = tmp.val();
      });

      calc();

      parentEl.find('.cost-param').on('change', function() {
        var changedEl = $(this);
        var changedValue = changedEl.val();
        var changedDataType = changedEl.data('type');
        combination[changedDataType] = changedValue;
        calc();
      });

      function calc() {
        $.each(types, function(index, value) {
          parentEl.attr('data-'+value, combination[value]);
        });

        if (!groupBy) {
          var values = Object.keys(combination).map(function (key) {
            return combination[key];
          });
          applyToElement(parentEl, dataBlock.cost[values.join('_')]);
        } else if (groupBy === 'packages') {
          parentEl.attr('data-typeOfCourse', combination.typeOfCourse);
          var groups = dataBlock.packagesAdaptive;
          var costData = dataBlock.costDataAdaptive;
          var combinationString = combination.duration;
          var groupAttr = 'data-group';
          var isCourseSystem = (combination.typeOfCourse === 'system');
          if (isCourseSystem) {
            groups = dataBlock.packagesStandart;
            costData = dataBlock.costDataStandart;
            combinationString = combination.program;
            groupAttr = 'data-group-course-system';
          }
          parentEl.find('.cost-select-wrapper.duration-wrapper').toggleClass('d-none', isCourseSystem);
          parentEl.find('.cost-select-wrapper.program-wrapper').toggleClass('d-none', !isCourseSystem);
          $.each(groups, function(index, group) {
            var card = parentEl.find('['+groupAttr+'="'+group+'"]');
            if (typeof costData[combinationString+'_'+group] !== 'undefined') {
              card.closest('.price-card-wrapper').removeClass('d-none');
              applyToElement(card, costData[combinationString+'_'+group]);
            } else {
              card.closest('.price-card-wrapper').addClass('d-none');
            }
          });
        }
      }

      function applyToElement(el, groupData) {
        el.find('.discount-value').html(groupData.discount_formatted);
        el.find('.package-cross-price-value').html(groupData.package_cross_price_formatted);
        el.find('.package-price-value').html(groupData.package_price_formatted);
        el.find('.lesson-price-value').html(groupData.lesson_price_formatted);
        el.find('.lesson-cross-price-value').html(groupData.lesson_cross_price_formatted);
        el.find('.selected-lessons-count').html(groupData.package_size);
        el.find('.consultations-count').html(groupData.consultations_count);
        el.find('.selected-lesson-length').html(groupData.duration);
        el.find('.package-comment').html(groupData.package_comment);
        el.find('.package-instalments-value').html(groupData.package_instalments_price_formatted);
        el.find('.discounts-row').toggleClass('hidden', (groupData.discount == 0));
        el.find('.campaign-end-date-value').toggleClass('d-none', groupData.no_campaign_discount);
      }
    },
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        Utils.commonScripts();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    'page_template_template_front_page': {
      init: function() {
        Utils.setYouTubeVideo(function(clickedElement) {
          clickedElement.closest('.testimonial-video-card').find('.overlay').hide();
        });
        Blocks.questionsBlock();
        Blocks.reviewsBlock();
        Blocks.reviewModal();
        Blocks.tabsBlock();
        if (global_settings.ncsActive) {
          Blocks.ncsTariffsBlock();
          Blocks.ncsTariffCardsBlock();
        } else {
          Blocks.frontPageCostBlock();
        }
      },
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
